import React from "react";
import defaultLayoutImage from "assets/images/png/login-layout-img.jpg";
import defaultLogo from "assets/images/svg/click-for-marry.svg";
import "./style.scss";

function AuthLayout({
  children,
  layoutImage,
  Logo,
  line1 = "Bond Of",
  line2 = "Safety in Love",
  line3 = "Best Place to find your Future Partner",
  isCustomText,
  childrenClass,
}) {
  return (
    <div className="auth-layout-container">
      <div className="auth-left">
        <span className="image-container">
          <img
            src={layoutImage || defaultLayoutImage}
            alt="auth-left"
            className="auth-left-image"
          />
        </span>

        <div className="auth-left-logo">
          <img src={Logo || defaultLogo} alt="Logo" />
        </div>

        <div
          className={`auth-left-text ${isCustomText ? "custom-position" : ""}`}
        >
          <p className={`line-1 ${isCustomText ? "custom-line" : ""}`}>
            {line1}
          </p>
          <p className={`line-2 ${isCustomText ? "custom-line" : ""}`}>
            {line2}
          </p>
          <p className={`line-3 ${isCustomText ? "custom-line" : ""}`}>
            {line3}
          </p>
        </div>
      </div>
      <div className={`auth-right ${childrenClass}`}>
        <div className="auth-form-container">{children}</div>
      </div>
    </div>
  );
}

export default AuthLayout;
